module.exports = __webpack_public_path__ + "static/media/minus-white.33cfc316.svg";